"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitService = void 0;
class InitService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1Init({ currentUserIp, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/init/{currentUserIp}',
            path: {
                currentUserIp: currentUserIp,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV1InitAuth({ currentUserIp, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/init/auth/{currentUserIp}',
            path: {
                currentUserIp: currentUserIp,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.InitService = InitService;
